module.exports = __webpack_public_path__ + "static/media/wrinkles_crowsfeet.52115b7a.svg";